export const ROOT_CURRENT_USER_STATE = 'user';

export const DEFAULT_DATE_FORMAT = 'YYYY/MM/DD';

export const INITIAL_STATE = {
  error: undefined,
  activeNotifications: [],
  accountsError: undefined,
  switchableAccounts: [],
  datapointDescriptors: [],
  dateFormat: DEFAULT_DATE_FORMAT
};

export const CurrentUserWhiteListKeys = [[ROOT_CURRENT_USER_STATE, 'id'], [ROOT_CURRENT_USER_STATE, 'account', 'id']];
